document.addEventListener("DOMContentLoaded", function () {
	const headerEl = document.querySelector("header");

	if (!headerEl) {
		return;
	}

	const positionInfo = headerEl.getBoundingClientRect();
	let offset = positionInfo.height;

	const stickyHeader = new Headroom(headerEl, {
		offset: offset,
		// scroller: ".wp-site-blocks",
	});

	stickyHeader.init();

	window.addEventListener("hashchange", function () {
		if (window.location.hash) {
			const hashEl = document.querySelector(window.location.hash);
			if (hashEl) {
				// If the element is hidden, open its closest <details>
				if (hashEl.offsetParent === null) {
					const details = hashEl.closest("details");
					if (details) {
						details.open = true;
					}
				}

				if (offset) {
					setTimeout(function () {
						const top = hashEl.getBoundingClientRect().top + window.pageYOffset - offset;
						window.scrollTo({ top: top, behavior: "auto" });
					}, 0);
				} else {
					hashEl.scrollIntoView({ behavior: "auto" });
				}
			}
		}
	});
});
